export default __webpack_public_path__ + "static/media/trevor-j-alt-blue.18a82648.png";